/** @jsxImportSource @emotion/react */
import type { ReactNode } from 'react';
import { statTileStyle, statLabelStyle, statValueStyle, statCaptionStyle } from './StatTile.styles';

/**
 * 색 계열. DQOps 시안의 success·warning에 admin-mockup의
 * neutral(모듈 수)·info(진행 중)·danger(실패)가 추가됨.
 */
export type StatTileTone = 'neutral' | 'success' | 'warning' | 'info' | 'danger';

export interface StatTileProps {
  /** 지표 이름. 예: "실패 (24h)" */
  label: ReactNode;
  /** 지표 수치. 예: "4" */
  value: ReactNode;
  /** 수치 아래 보조 설명. 예: "3개 모듈 · 확인 필요" (선택) */
  caption?: ReactNode;
  tone?: StatTileTone;
}

/** 수치 요약 타일. 대시보드 KPI 줄(모듈·진행 중·실패)에 활용. */
export function StatTile({ label, value, caption, tone = 'neutral' }: StatTileProps) {
  return (
    <div css={statTileStyle(tone)}>
      <div css={statLabelStyle(tone)}>{label}</div>
      <div css={statValueStyle(tone)}>{value}</div>
      {caption !== undefined && <div css={statCaptionStyle(tone)}>{caption}</div>}
    </div>
  );
}
